module.exports = __webpack_public_path__ + "static/ContributionsSingle-82682a54e4af70109fbe32019164b943.png";